import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";

export const INSERT_DOCUMENT_DOWNLOAD_EVENT = 'INSERT_DOCUMENT_DOWNLOAD_EVENT';

export const service = async (data) => {
    const response: any = await callMdaePublicApi({
        type: 'post',
        contentType: 'application/json',
        url:  '/Api/Document/InsertDocumentEvent',
        isRoutedApiCall: true,
        ...getDefaultOptions(),
        body: JSON.stringify({
            eventName: "Download",
            documentId: data.documentId,
            attachedLevelName: data.attachedLevelName ?? 'auditCase',
            attachedLevelId: data.attachedLevelId
        })
    })
    throwExceptionErrors(response);
    return response;

};

const mockData = () => {
    return ([])
};

const mock = () => Promise.resolve(mockData());

register(INSERT_DOCUMENT_DOWNLOAD_EVENT, service, mock);
